import axios from 'axios';
import { REST_HOSTNAME } from '../Config';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export interface ICourse {
    id: number;
    order_index: number;
    name: string;
    description?: string;
    is_hidden: boolean;
    expanded?: boolean;
    dialogPromptCount?: number;
    userDialogPromptCount?: number;
}

export const CourseApi = {
    getAll: function () {
        return axiosInstance.request<ICourse[]>({
            method: "GET",
            url: `/course`
        });
    },
    getById: function (courseId: number) {
        return axiosInstance.request<ICourse>({
            method: "GET",
            url: `/course/${courseId}`
        });
    },
    create: function (course: ICourse) {
        return axiosInstance.request<ICourse>({
            method: "POST",
            url: `/course`,
            data: course
        });
    },
    update: function (course: ICourse) {
        return axiosInstance.request<string>({
            method: "PUT",
            url: `/course`,
            data: course
        });
    },
    delete: function (courseId: number) {
        return axiosInstance.request<string>({
            method: "DELETE",
            url: `/course/${courseId}`,
        });
    },
}
